import { DsEmitterUserGroupInterface } from '../interfaces/ds-emitter-user-group.interface';

export class DsEmitterUserGroup {
  /**
   * User group id
   */
  id: number;

  /**
   *
   */
  rightId: number;

  /**
   *
   */
  emitterId: number;

  /**
   * Creates an instance of DsEmitterUserGroup.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsEmitterUserGroupInterface) {
    this.id = jsonData.group_id;
    this.rightId = jsonData.right_id;
    this.emitterId = jsonData.emitter_id;
  }
}
